// Official NARA "Daily Wellness" circular badge logo.
export const BrandBadge = ({ size = 140, className = "", spin = true }) => (
  <img
    src="/images/brand/icon_a.png"
    alt="NARA Nutrition · Daily Wellness"
    style={{ width: size, height: size }}
    className={`object-contain ${spin ? "animate-spin-slow" : ""} ${className}`}
  />
);

export default BrandBadge;
